var RequestTypes;
(function (RequestTypes) {
    RequestTypes["Identity"] = "identity";
    RequestTypes["Track"] = "track";
    RequestTypes["Set"] = "set";
    RequestTypes["Group"] = "group";
    RequestTypes["Page"] = "page";
    RequestTypes["Alias"] = "alias";
})(RequestTypes || (RequestTypes = {}));
export default RequestTypes;
//# sourceMappingURL=RequestTypes.js.map